module.exports = __webpack_public_path__ + "img/bild-c.d88531ab.png";